export function copyUrl() {
  const button = document.querySelectorAll('.js-copy-url');
  if(button.length) {
    for (let i = 0; i < button.length; i++) {
      const el = button[i];
      const label = el.querySelector('.js-label');
      const labelText = label.textContent;
      const labelCopied = el.getAttribute('data-copied-text');
      el.addEventListener('click', function(e) {
        e.preventDefault();
        const url = location.href;
        navigator.clipboard.writeText(url);
        label.innerText = labelCopied;
        setTimeout(() => {
          label.innerText = labelText;
        }, 1000)
      });
    }
  }
}